export default __webpack_public_path__ + "static/media/ru.1d20e193.svg";